let times = { NAV: 0, OPN: 0, CLS: 0, RDY: 0, FIN: 0, EXT: 0 }
let trace = false
const infos = {
    OPN: 'Open',
    RDY: 'Ready',
    CLS: 'Close'
}

export default function perfTrace(navigation, tag) {
    trace = true
    let delta = 0
    const now = Date.now()
    switch (tag) {
        case 'OPN':
            delta = now - (times.CLS || times.NAV)
            break
        case 'RDY':
            delta = now - (times.RDY || times.OPN || times.NAV)
            break
        case 'UPD':
        case 'CLS':
            delta = now - (times.UPD || times.RDY || times.NAV)
            break
        case 'FIN':
            delta = now - times.UPD
            break
        case 'EXT':
            delta = times.FIN ? now - times.UPD : 0
            break
    }
    times[tag] = now
    const navState = navigation.getState()
    const screen = navState.routes[navState.index].name
    console.info('SCREEN ' + tag, screen, now, delta)
    return { screen: screen, now: now, delta: delta, tag: tag, info: infos[tag] }
}

export function switchScreen(navigation, component, params) {
    params = params || {}
    times = { NAV: Date.now(), OPN: 0, CLS: 0, RDY: 0, FIN: 0, EXT: 0 }
    if (trace) {
        console.info('SCREEN NAV', component, times.NAV)
    }
    switch (component) {
        case 'BACK2':
            navigation.goBack()
        case 'BACK':
            navigation.goBack()
            break
        default:
            navigation.navigate(component, params, {pop: true})
    }
    if (component == 'BACK') {
    } else {
    }
}
